/* crst-business-fx.js — page-specific FX for the For Business page.
   Relocated verbatim (behavior-for-behavior) from the former monolith
   sections/crst-business.liquid inline <script>, after the monolith was split into
   independent, draggable crst-business-* module sections:
     1) scroll-reveal (fade-up on enter, honors data-delay + reduced-motion) — this is
        ALSO what drives the M5 pricebar bar animation: revealing a `.pricebar.reveal`
        adds `.in`, and `.crst-business-value .pricebar.in .pb-seg{width:var(--w)}` grows
        the CSS bars. No separate pricebar JS exists (or ever did).
     2) count-up on the `.big` stat numbers (M2 proof: 15% / 50,000+ — the real, disclosed
        figures; M7 service: 24h / 36-mo / $3M). Kept on `.big`, NOT the site-wide
        [data-countup] convention, because the monolith parsed/animated `.big` directly —
        switching selectors would be a markup change, so this stays page-specific.
     3) M4 supply-chain feature image parallax.
     4) M14 floating CTA dock — reveals after the hero scrolls past, hides near the RFQ form.

   Why a page-specific bundle instead of the shared crst-home-fx.js (mirrors crst-why-fx.js):
   the business count-up is on `.big` (not [data-countup]) and importing crst-home-fx would
   also bind its [data-compare]/[data-rail-wrap]/[data-add-id] handlers this page doesn't use
   and change count-up behavior. So all business behaviors live here, run-once + document-
   scoped so every crst-business-* section can include it safely (multiple includes = one
   execution). Each sub-handler no-ops when its markup is absent (dock needs .biz-hero + #rfq
   + [data-biz-dock], which after the split live in three separate sections on the same page). */
(function(){
  if(window.__crstBizFx)return;window.__crstBizFx=1;

  function init(){
    var root=document;

    /* scroll reveal — fade up on enter, honors data-delay + reduced-motion.
       (Copied from crst-why-fx.js, incl. the first-fold backstop so a just-below-the-fold
       module never sits blank for the first ~120px of scrolling.) */
    (function(){
      var els=root.querySelectorAll('.reveal'); if(!els.length) return;
      if(window.matchMedia('(prefers-reduced-motion:reduce)').matches || !('IntersectionObserver' in window)){
        els.forEach(function(el){ el.classList.add('in'); }); return;
      }
      var io=new IntersectionObserver(function(ents){
        ents.forEach(function(en){
          if(!en.isIntersecting) return;
          var d=en.target.getAttribute('data-delay'); if(d) en.target.style.transitionDelay=d+'ms';
          en.target.classList.add('in'); io.unobserve(en.target);
        });
      },{threshold:0.08,rootMargin:'0px 0px -6% 0px'});
      /* First-fold backstop: anything at or near the fold reveals on load — the scroll
         gate otherwise leaves a just-below-the-fold module blank on fold-height viewports. */
      var vh=window.innerHeight||document.documentElement.clientHeight||0;
      els.forEach(function(el){
        var r=vh?el.getBoundingClientRect():null;
        if(r && r.top<vh*1.2 && r.bottom>-40){
          var d=el.getAttribute('data-delay'); if(d) el.style.transitionDelay=d+'ms';
          el.classList.add('in');
        } else {
          io.observe(el);
        }
      });
    })();

    /* count-up on .big stat numbers (M2 proof 15% / 50,000+ + M7 service 24h / 36-mo / $3M —
       real disclosed figures). Animates 0→value when scrolled into view; reduced-motion /
       no-IO leaves the static SSR value untouched. */
    (function(){
      var nums=root.querySelectorAll('.big'); if(!nums.length) return;
      if(window.matchMedia('(prefers-reduced-motion:reduce)').matches || !('IntersectionObserver' in window)) return;
      function parse(el){ var m=(el.textContent||'').match(/^(\D*)([\d,]+)(.*)$/); if(!m) return null; var t=parseInt(m[2].replace(/,/g,''),10); if(isNaN(t)) return null; return {pre:m[1],target:t,suf:m[3]}; }
      function run(el,info){
        if(el._cuRan) return; el._cuRan=true;   // guard: IO + rAF-fallback must not both animate
        var dur=1400, t0=null;
        function step(ts){
          if(!t0) t0=ts; var p=Math.min(1,(ts-t0)/dur), eased=1-Math.pow(1-p,3);
          el.textContent=info.pre+Math.round(info.target*eased).toLocaleString('en-US')+info.suf;
          if(p<1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      var io=new IntersectionObserver(function(ents){
        ents.forEach(function(en){ if(en.isIntersecting && en.target._cu){ run(en.target,en.target._cu); io.unobserve(en.target); } });
      },{threshold:0.4});
      // parse + reset to 0 immediately (avoids the final value flashing before the element scrolls into view)
      nums.forEach(function(n){ var info=parse(n); if(!info) return; n._cu=info; n.textContent=info.pre+'0'+info.suf; io.observe(n); });
      /* Belt-and-suspenders: a tall stat block may never reach the 0.4 ratio (or the IO
         context can report innerHeight 0), leaving the number stuck at 0. After first
         layout, run count-up for any stat already within the viewport; the observer still
         handles the rest on scroll. */
      requestAnimationFrame(function(){
        var vh=window.innerHeight||document.documentElement.clientHeight||0;
        nums.forEach(function(n){ if(!n._cu) return; var r=n.getBoundingClientRect(); if(r.top<vh*0.94 && r.bottom>0){ run(n,n._cu); io.unobserve(n); } });
      });
    })();

    /* M4 subtle parallax on the supply-chain feature image (design parity; reduced-motion safe) */
    (function(){
      var fi=root.querySelector('.feat-inner');
      if(!fi || window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
      var feat=fi.parentElement, raf=null;
      function px(){
        raf=null;
        var r=feat.getBoundingClientRect(), vh=window.innerHeight||document.documentElement.clientHeight;
        if(r.bottom<0||r.top>vh) return;
        var prog=(r.top+r.height/2-vh/2)/vh, y=Math.max(-1,Math.min(1,prog))*-5;
        fi.style.transform='translateY('+y.toFixed(2)+'%)';
      }
      window.addEventListener('scroll',function(){ if(!raf) raf=requestAnimationFrame(px); },{passive:true});
      window.addEventListener('resize',function(){ if(!raf) raf=requestAnimationFrame(px); },{passive:true});
      px();
    })();

    /* M14 floating CTA dock — reveals once the hero scrolls past, hides near the quote form.
       After the split, .biz-hero (hero section), #rfq (rfq section) and [data-biz-dock]
       (dock section) live in three separate sections — so all queries are document-scoped. */
    (function(){
      var dock=root.querySelector('[data-biz-dock]'); if(!dock) return;
      var hero=root.querySelector('.biz-hero');
      var rfqSec=root.querySelector('#rfq');
      var closeBtn=dock.querySelector('[data-dock-close]');
      var dismissed=false;

      function setShown(show){
        show = show && !dismissed;
        dock.classList.toggle('show',show);
        dock.setAttribute('aria-hidden', show?'false':'true');
      }
      if(closeBtn){
        closeBtn.addEventListener('click',function(){ dismissed=true; setShown(false); });
      }

      if(!('IntersectionObserver' in window) || !hero){
        setShown(false); return;
      }

      var heroPassed=false, rfqInView=false;
      function refresh(){ setShown(heroPassed && !rfqInView); }

      // hero gate: dock appears only after the hero (with its primary CTAs) scrolls out of view
      var heroIo=new IntersectionObserver(function(ents){
        heroPassed = ents[0].intersectionRatio <= 0.01 && ents[0].boundingClientRect.bottom < 0;
        refresh();
      },{threshold:[0,0.01]});
      heroIo.observe(hero);

      // suppress the dock while the quote form itself is on screen (avoids duplicate CTAs)
      if(rfqSec){
        var rfqIo=new IntersectionObserver(function(ents){
          rfqInView = ents[0].isIntersecting;
          refresh();
        },{rootMargin:'0px 0px -120px 0px',threshold:0});
        rfqIo.observe(rfqSec);
      }
    })();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  } else {
    init();
  }
})();
